
import React, { useMemo, useState, useEffect } from "react";
import { connect } from 'react-redux';
import { useTable, usePagination, useSortBy, useExpanded, useResizeColumns, useFlexLayout } from "react-table";
import { QueryClient, QueryClientProvider, useQuery } from 'react-query'
import ReactTablePagination from '@/shared/components/table/components/ReactTablePagination';
import FolderMoveOutlineIcon from 'mdi-react/FolderMoveOutlineIcon';
import PencilOutlineIcon from 'mdi-react/PencilOutlineIcon';
import { reducer, useEffectToDispatch, fetchApiData, initialState, Sorting } from "@/shared/apiTableHelper"
import { getProgramById } from "@/shared/apiHelper"
import SelectProgram from "@/containers/Manager/components/SelectProgram";
import ChangeStatusModal from "@/containers/Manager/ManageProgram/components/ChangeStatusModal"

import {
  Button,
  Container,
  Card,
  CardBody,
  Row,
  Col,
} from "reactstrap";
import ProgramFilter from "../../components/ProgramsFilter";

import { PROGRAM_COLUMNS } from "./columns";

import { renameChildrenToSubrows } from '@/shared/helpers'
import AddSubProgramModal from './AddSubProgramModal'
import MoveSubProgramModal from "./MoveSubProgramModal"
import RenameSubProgramModal from "./RenameSubProgramModal"
import { useDispatch, sendFlashMessage } from "@/shared/components/flash"

const queryClient = new QueryClient()

const DataTable = ({ organization, program, embedded = false }) => {
  const flashDispatch = useDispatch()
  const [filter, setFilter] = useState({ status: '', keyword: '' });
  const [useFilter, setUseFilter] = useState(false);
  const [movingSubProgram, setMovingSubProgram] = useState(null)
  const [isMoveOpen, setMoveOpen] = useState(false)
  const [renamingSubProgram, setRenamingSubProgram] = useState(null)
  const [isRenameOpen, setRenameOpen] = useState(false)
  const [loading, setLoading] = useState(true)
  const [trigger, setTrigger] = useState(0);

  const [isChangeStatusOpen, setChangeStatusOpen] = useState(false)
  const [subprogram, setSubprogram] = useState(null) //used in change status modal

  const onClickStartMoveSubProgram = (program) => {
    setMovingSubProgram(program)
    setMoveOpen(true)
  }

  const onClickStartRenameSubProgram = (program) => {
    setRenamingSubProgram(program)
    console.log(program)
    setRenameOpen(true)
  }

  const renameToggle = () => {
    setRenameOpen(prevState => !prevState)
  }

  // var [data, setData] = useState([]);
  const [isOpen, setOpen] = useState(false)

  const toggle = () => {
    setOpen(prevState => !prevState)
  }
  const moveToggle = () => {
    setMoveOpen(prevState => !prevState);
  };
  const onClickFilterCallback = (status, keyword) => {
    if (filter.status === status && filter.keyword === keyword) {
      alert('No change in filters')
      setUseFilter(false);
      return
    }
    setUseFilter(true);
    setFilter({ status, keyword })
    // alert(status, keyword)
  }

  const RenderActions = ({ row }) => {
    return (
      <>
        <span title="Rename"><PencilOutlineIcon onClick={() => onClickStartRenameSubProgram(row.original)} style={{ cursor: 'pointer' }} /></span>
        <span style={{ width: '10px', display: 'inline-block' }}></span>
        <span title="Move node"><FolderMoveOutlineIcon onClick={() => onClickStartMoveSubProgram(row.original)} style={{ cursor: 'pointer' }} disabled={loading} /></span>
      </>
    )
  }
  const toggleChangeStatus = () => {
    setChangeStatusOpen(prevState => !prevState)
  }
  const onClickStatus = p => {
    setSubprogram(p);
    toggleChangeStatus()
  }

  const strShowUserStatus = p => {
    return p?.status?.status ? <span onClick={() => onClickStatus(p)} className={'link'}>{p.status.status}</span> : (p?.status_id ? p.status_id : 'unknown')
  }

  let columnns = [
    ...PROGRAM_COLUMNS,
    ...[{
      Header: "Action",
      accessor: "action",
      Cell: ({ row }) => <RenderActions row={row} />,
    }]
  ]

  columnns.forEach( (column, i) => {
    if( column.Header === 'Status')
    {
      columnns[i].Cell =  ({ row, value }) => { return strShowUserStatus(row.original)}
    }
  })

  let columns = useMemo(() => columnns, [])
  const defaultColumn = React.useMemo(
    () => ({
      minWidth: 30,
      width: 150,
      maxWidth: 400,
    }),
    []
  )

  const [{ queryPageIndex, queryPageSize, totalCount, queryPageFilter, queryPageSortBy, queryTrigger }, dispatch] =
    React.useReducer(reducer, embedded ? { ...initialState, queryPageSize: 9999999999 } : initialState);

  const apiUrl = `/organization/${program.organization_id}/program/${program.id}/subprogram`

  const { isLoading, error, data, isSuccess } = useQuery(
    ['roles', apiUrl, queryPageIndex, queryPageSize, queryPageFilter, queryPageSortBy, queryTrigger],
    () => fetchApiData(
      {
        url: apiUrl,
        page: queryPageIndex,
        size: queryPageSize,
        filter: queryPageFilter,
        sortby: queryPageSortBy,
        trigger: queryTrigger
      }),
    {
      keepPreviousData: true,
      staleTime: Infinity,
    }
  );

  const totalPageCount = Math.ceil(totalCount / queryPageSize)

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page,
    pageCount,
    pageOptions,
    gotoPage,
    previousPage,
    canPreviousPage,
    nextPage,
    canNextPage,
    setPageSize,
    state: { pageIndex, pageSize, sortBy }
  } = useTable({
    columns,
    data: data ? data.results : [],
    initialState: {
      pageIndex: queryPageIndex,
      pageSize: queryPageSize,
      sortBy: queryPageSortBy,
    },
    manualPagination: true, // Tell the usePagination
    pageCount: data ? totalPageCount : null,
    autoResetSortBy: false,
    autoResetExpanded: false,
    autoResetPage: false,
    defaultColumn,

  },
    useSortBy,
    useExpanded,
    usePagination,
    useResizeColumns,
    useFlexLayout,
  );
  const manualPageSize = [];

  if (data?.results?.length > 0) {
    data.results = renameChildrenToSubrows(data.results);
  }

  useEffectToDispatch(dispatch, { pageIndex, pageSize, gotoPage, sortBy, filter, data, useFilter, trigger });

  if (error) {
    return <p>Error: {JSON.stringify(error)}</p>;
  }

  if (isLoading) {
    return <p>Loading...</p>;
  }
  if (isSuccess)
    return (
      <>
        <div className={`table react-table${embedded ? ' manager-program-admin__embedded-table' : ''}`}>
          <div className={`form form--horizontal${embedded ? ' manager-program-admin__embedded-toolbar' : ''}`}>
            <div className="form__form-group pb-4">
              {!embedded && (
                <Row style={{marginBottom:0 }}>
                  <Col md="6">
                    <SelectProgram />
                  </Col>
                  <Col md="6" style={{textAlign: 'right'}}>
                    <a style={{ maxWidth: '200px' }}
                      className="btn btn-primary account__btn account__btn--small"
                      href="/manager/manage/program"
                    >
                      Back
                    </a>
                  </Col>
                </Row>
              )}
              <Row>
                <Col md={12}>
                  <ProgramFilter onClickFilterCallback={onClickFilterCallback} organization={organization} />
                </Col>
              </Row>
            </div>
          </div>

           {subprogram && <ChangeStatusModal 
              isOpen={isChangeStatusOpen} 
              setOpen={setChangeStatusOpen}
              toggle={toggleChangeStatus} 
              setTrigger={setTrigger} 
              program={subprogram} 
              />}
          <AddSubProgramModal program={program} organization={organization} isOpen={isOpen} setOpen={setOpen} toggle={toggle} setTrigger={setTrigger} />
          <div className="manager-program-admin__table-shell">
            <table {...getTableProps()} className="table table--stack-mobile">
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(column => (
                      <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                        {column.render('Header')}
                        {column.isSorted ? <Sorting column={column} /> : ''}
                        <div
                          {...column.getResizerProps()}
                          className={`resizer ${column.isResizing ? 'isResizing' : ''
                            }`}
                        />
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody className="" {...getTableBodyProps()}>
                {page.map(row => {
                  prepareRow(row);
                  const subCount = (row.id.match(/\./g) || []).length
                  return (
                    <tr {...row.getRowProps()}>
                      {
                        row.cells.map(cell => {
                          const paddingLeft = subCount * 20
                          return <td
                            {...cell.getCellProps()}
                            data-label={typeof cell.column.Header === 'string' ? cell.column.Header : ''}
                          ><span style={cell.column.Header === '#' ? { paddingLeft: `${paddingLeft}px` } : null}>{cell.render('Cell')}</span></td>
                        })
                      }
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          {movingSubProgram && <MoveSubProgramModal organization={organization} isOpen={isMoveOpen} setOpen={setMoveOpen} toggle={moveToggle} subprogram={movingSubProgram} setTrigger={setTrigger} />}
          {renamingSubProgram && <RenameSubProgramModal organization={organization} isOpen={isRenameOpen} setOpen={setRenameOpen} toggle={renameToggle} subprogram={renamingSubProgram} setTrigger={setTrigger} />}
        
        </div>
        {(rows.length > 0) && !embedded && (
          <div className="manager-program-admin__pagination">
            <ReactTablePagination
              page={page}
              gotoPage={gotoPage}
              previousPage={previousPage}
              nextPage={nextPage}
              canPreviousPage={canPreviousPage}
              canNextPage={canNextPage}
              pageOptions={pageOptions}
              pageSize={pageSize}
              pageIndex={pageIndex}
              pageCount={pageCount}
              setPageSize={setPageSize}
              manualPageSize={manualPageSize}
              dataLength={totalCount}
            />
            {/* <div className="pagination justify-content-end mt-2">
              <span>
                Go to page:{' '}
                <input
                  type="number"
                  value={pageIndex + 1}
                  onChange={(e) => {
                    const page = e.target.value ? Number(e.target.value) - 1 : 0;
                    gotoPage(page);
                  }}
                  style={{ width: '100px' }}
                />
              </span>{' '}
              <select
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                }}
              >
                {[10, 20, 30, 40, 50].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
            </div> */}
          </div>
        )}
      </>
    )
}

const SubProgram = ({ organization, program, embedded = false }) => {
  if (embedded) {
    return (
      <div className="manager-program-admin__embedded-view">
        <DataTable organization={organization} program={program} embedded={true} />
      </div>
    );
  }

  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Sub Programs</h3>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <DataTable organization={organization} program={program} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

const TableWrapper = ({ organization, theme, rtl, program, embedded = false }) => {
  const [programData, setProgramData] = useState(null);
  useEffect(() => {
    if (organization && program) {
      getProgramById(organization?.id, program?.id, {'hierarchy':true})
        .then(p => {
          console.log(p);
          setProgramData(p)
        })
    }
  }, [organization, program])

  if (!organization || !programData) return 'Loading...'

  return (
    <QueryClientProvider client={queryClient}>
      <SubProgram organization={organization} program={programData} theme={theme} rtl={rtl} embedded={embedded} />
    </QueryClientProvider>
  )
}

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
    rtl: state.rtl,
    organization: state.organization,
    program: state.program
  };
};

export default connect(mapStateToProps)(TableWrapper);
